import axios from "../assets/api/serve.js";

//新闻列表
export function showNewsList(params)
{
	return axios.get("/portal/gov/showNoticeList",{
		params:params
	})
}

//新闻详情
export function showNoticeDetail(params)
{
	return axios.get(`/portal/gov/showNoticeDetail/${params}`)
}

//主要产品
export function getAreaProductList(params)
{
	return axios.get(`/portal/gov/getAreaProductList/${params}`)
}